/**
 * Call Cloudflare Worker endpoint. Cache result in a cookie for 48h. Exposes window.__GEO__. 
 * If ?showGeo=true is in the URL, appends window.__GEO__ as JSON at the bottom of the page.
 */
(function () {
    const WORKER_URL = "https://geolocate.swyft.workers.dev";
    const COOKIE_NAME = "geo_city_cache";
    const MAX_AGE_SECONDS = 48 * 60 * 60; // 48 hours

    function readCookie(name) {
        const m = document.cookie.match(
            new RegExp(
                "(?:^|; )" +
                    name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") +
                    "=([^;]*)"
            )
        );
        if (!m) return null;
        try {
            return JSON.parse(decodeURIComponent(m[1]));
        } catch {
            return null;
        }
    }

    function writeCookie(name, value, maxAgeSec) {
        const str = encodeURIComponent(JSON.stringify(value));
        document.cookie = `${name}=${str}; Max-Age=${maxAgeSec}; Path=/; SameSite=Lax`;
    }

    const cached = readCookie(COOKIE_NAME);
    const params = new URLSearchParams(window.location.search);
    const shouldShowGeo = params.get("showGeo")?.toLowerCase() === "true";

    function appendGeoToPage(geoData) {
        const pre = document.createElement("pre");
        pre.textContent = JSON.stringify(geoData, null, 2);
        pre.style.cssText = `
            background: #0b1020;
            color: #dfe7ff;
            padding: 16px;
            margin: 24px 0;
            border-radius: 8px;
            overflow-x: auto;
            font-size: 13px;
            line-height: 1.5;
            font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        `;

        const title = document.createElement("div");
        title.textContent = "window.__GEO__ contents";
        title.style.cssText = `
            font-family: sans-serif;
            font-size: 14px;
            font-weight: 600;
            margin-top: 32px;
            margin-bottom: 6px;
        `;

        document.addEventListener("DOMContentLoaded", () => {
            document.body.appendChild(title);
            document.body.appendChild(pre);
        });
    }

    function handleGeo(geo) {
        window.__GEO__ = geo;
        document.documentElement.setAttribute("data-zip", geo.zip || "");
        if (shouldShowGeo) appendGeoToPage(geo);
    }

    if (cached && cached.expires > Date.now()) {
        handleGeo(cached.data);
        return;
    }

    fetch(WORKER_URL, { mode: "cors", credentials: "omit" })
        .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
        .then((geo) => {
            if (!geo || !geo.ok) return;
            handleGeo(geo);
            writeCookie(
                COOKIE_NAME,
                { data: geo, expires: Date.now() + MAX_AGE_SECONDS * 1000 },
                MAX_AGE_SECONDS
            );
            // Example: region-based action
            // if (geo.countryCode === "GB") showUKBanner();
        })
        .catch((err) => console.warn("Geo lookup failed", err));
})();
